
import sHeader from "../components/sheader.vue"
import checkout from "@/components/checkout/index.vue"

export default {
  components: {
    checkout,
    sHeader
  },
  layout: "onlyFooter",
  data() {
    return {}
  },
  mounted() {
    document.title = this.$t("pageTitle.checkout")
  }
}
